import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../ajs-upgraded-providers';
import { ngListService } from '../../list/core/ng-list.service';
import { LtiService } from '../../lti/core/lti.service';
import { AssignmentService } from '../core/assignment.service';
import { Assignment } from '../shared/assignment';

@Component({
  selector: 'rl-assignment-full',
  templateUrl: './assignment-full.component.html',
  styleUrls: ['./assignment-full.component.scss']
})
export class AssignmentFullComponent implements OnInit {

  asgmt : Assignment = new Assignment();
  asgmtView : boolean;
  student : boolean = true;
  fromLms : boolean;

  constructor(private route: ActivatedRoute, private assignmentService : AssignmentService, private lti : LtiService) {}

  ngOnInit(): void {
    this.fromLms = this.lti.isOn();
    
    this.route.paramMap.subscribe(params => this.loadAssignment(params.get('id')));
  }

  loadAssignment(asgmtId : string){
    this.assignmentService.get(asgmtId || this.asgmt.id).subscribe(a => {
      
      this.asgmt = a;
      
      this.student = !a.owner;
      
      this.asgmtView = this.student || !this.fromLms;

      if(this.asgmt.dueDate) this.asgmt.dueDate = new Date(this.asgmt.dueDate);
    });
  }
}